import Prefixes from './Prefixes'

export default Prefixes
